import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { isEmpty } from "lodash";

import Color from "@tool/color";
import TalentPortrait from "./component/talent-portrait";
import { talentFlowInit } from "./store/portrait";
import MobilityOverview from "./component/mobility-overview";
import { mobilityInit } from "./store/mobility";
import { useParams } from "react-router-dom";
import moIndex from "../store";
import { toggleValue } from "@/store";

interface IProps {}
interface IState {}

// 人才流动
const TalentFlow = (props: IProps, state: IState) => {
  const navi = useParams();
  const { industry } = moIndex;

  const init = async () => {
    toggleValue("isLoading", true);
    await talentFlowInit();
    await mobilityInit();
    const mobility: any = document.getElementById("mobility");
    const talent: any = document.getElementById("talent");
    if (navi.id === "0") {
      const top = mobility.offsetTop;
      window.scrollTo(0, 0);
    }
    if (navi.id === "1") {
      const top = mobility.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "2") {
      const top = talent.offsetTop;
      window.scrollTo(0, top + 90);
    }
    toggleValue("isLoading", false);
    setTimeout(() => {
      toggleValue("isLoading", false);
    }, 5000);
  };

  useEffect(() => {
    if (industry.code) {
      init();
    }
    return () => {};
  }, []);

  useEffect(() => {
    const mobility: any = document.getElementById("mobility");
    const talent: any = document.getElementById("talent");
    if (navi.id === "0") {
      const top = mobility.offsetTop;
      window.scrollTo(0, 0);
    }
    if (navi.id === "1") {
      const top = mobility.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "2") {
      const top = talent.offsetTop;
      window.scrollTo(0, top + 90);
    }
    return () => {};
  }, [navi]);

  return (
    <section className="talent-flow-warp">
      <MobilityOverview />
      <TalentPortrait />
    </section>
  );
};

export default observer(TalentFlow);
